import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 980px;
  width: 980px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media only screen and (max-width: 950px) {
    justify-content: flex-start;
    align-items: center;
    max-width: 100%;
  }
`;

export const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 36px;
  margin-bottom: 68px;

  @media only screen and (max-width: 950px) {
    margin-top: 0px;
  }
`;

export const Title = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0.3em;
  color: #475467;
  text-transform: uppercase;

  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #475467;
  }
`;

export const SubTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 60px;
  text-transform: uppercase;
  color: #475467;

  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    text-transform: uppercase;
    color: #475467;
  }
`;

export const Grid = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Row = styled.div`
  width: 100%;
  max-width: 980px;
  display: ${props => (props.hide ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 40px;

  .selected {
    background: ${props => darken(0.08, props.primaryColor || '#36397A')};
    color: #fff;
  }

  p {
    border: 1px solid ${props => props.primaryColor || '#36397a'};
    opacity: 0.5;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${props => props.primaryColor || '#36397a'};

    :hover {
      background: ${props => darken(0.08, props.primaryColor || '#36397A')};
      color: #fff;
    }
  }
`;

export const ContainerEmpty = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
  background: #fff;
  padding: 50px;

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 96px;
    line-height: 121px;
    color: #475467;
  }

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #667085;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #667085;
  }

  a {
    background: ${props => props.primaryColor || '#36397A'};
    width: 280px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    text-decoration: none;
    :hover {
      background: ${props => darken(0.1, props.primaryColor || '#36397A')};
    }
    color: #fff;

    @media only screen and (max-width: 950px) {
      width: 100%;
    }
  }
`;
